export const config = {
  title: "MCA Deck's Construction LLC",
  meta: {
    description:
      "MCA Deck's Construction LLC offers expert deck and patio remodeling, residential construction, and renovation services in Lilburn, GA, ensuring exceptional craftsmanship and customer satisfaction.",
    keywords: [
      "Deck Remodeling",
      "Patio Remodeling",
      "Residential Construction",
      "Home Renovation",
      "MCA Deck's Construction LLC",
      "Lilburn GA Construction",
      "Home Remodeling",
      "Construction Services",
    ],
    author: "MCA Deck's Construction LLC",
    canonicalUrl: "https://mcadecksconstructionllc.com/",
  },
  sections: {
    header: {
      businessName: "MCA Deck's Construction LLC",
    },
    sectionB: {
      heroTitle: "MCA Deck's Construction LLC",
      heroSubtitle: "Expert Deck & Patio Remodeling in Lilburn, GA",
      learnAboutText: "Learn About Our Services",
      phoneNumber: "4044726553",
      phoneLabel: "(404) 472-6553",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1920930952/photo/outdoor-wooden-terrace-with-work-tools.jpg?s=612x612&w=0&k=20&c=y9EFwIPsxEJh_nItzHunfdwzNiz9-Hwhkp5la0ka_0I=",
      cardData: [
        {
          title: "Exceptional Craftsmanship",
          description:
            "Delivering high-quality construction with meticulous attention to detail.",
        },
        {
          title: "Customer Satisfaction",
          description:
            "Committed to exceeding client expectations on every project.",
        },
        {
          title: "Comprehensive Services",
          description:
            "Offering a wide range of construction and remodeling solutions.",
        },
      ],
      description:
        "With over 20 years of experience, MCA Deck's Construction LLC specializes in deck and patio remodeling, residential construction, and comprehensive renovation services in Lilburn, GA.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Explore our range of professional construction and remodeling services designed to enhance your living spaces.",
      cards: [
        {
          title: "Deck and Patio Remodeling",
          description:
            "Transform your outdoor spaces with our expert deck and patio remodeling services.",
          imageSrc:
            "https://media.istockphoto.com/id/912332782/photo/wooden-deck-of-family-home.jpg?s=612x612&w=0&k=20&c=GheSzJRveFdPMGZ9zRXhBR0zD0Gicr1cqJci-LL2ZfM=",
          imageAlt: "Deck and Patio Remodeling",
        },
        {
          title: "Residential Construction",
          description:
            "Providing top-quality residential construction services to bring your dream home to life.",
          imageSrc:
            "https://media.istockphoto.com/id/1429455427/photo/carpenter-installing-decking-boards.jpg?s=612x612&w=0&k=20&c=XbSuJAECV6Y56NMboHrelaieaB8V2j_awcCuhKKG-yc=",
          imageAlt: "Residential Construction",
        },
        {
          title: "Renovation and Remodeling",
          description:
            "Offering comprehensive renovation and remodeling solutions to update and improve your home.",
          imageSrc:
            "https://media.istockphoto.com/id/1822827952/photo/ipe-wood-terrace-deck-construction-view-of-carpenter-hands-with-a-spirit-level-and.jpg?s=612x612&w=0&k=20&c=ZCgMY7N9ol0lEmQLXyAUgZQ_uSkf08HQkSDUVvjAS-I=",
          imageAlt: "Renovation and Remodeling",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Custom Carpentry",
        "Outdoor Living Spaces",
        "Home Additions",
        "Basement Finishing",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://firebasestorage.googleapis.com/v0/b/interscopemediacrm.appspot.com/o/Clientes%2F271cb545-3ff3-4e29-832f-522e16e5f318%2F271cb545-3ff3-4e29-832f-522e16e5f318_whiteLogo.webp?alt=media&token=392ea07b-bb90-4b43-b938-19ce27f7236f",
        alt: "MCA Deck's Construction LLC Team",
      },
      aboutText: [
        "MCA Deck's Construction LLC is a trusted construction company based in Lilburn, GA, with over 20 years of experience.",
        "We are dedicated to providing exceptional craftsmanship and customer satisfaction in every project we undertake.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "MCA Deck's Construction LLC Logo",
      businessName: "MCA Deck's Construction LLC",
      contact: {
        phone: "4044726553",
        phoneLabel: "(404) 472-6553",
        email: "manialva54@gmail.com",
        website: "https://mcadecksconstructionllc.com/",
        address: "Lilburn, GA",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "Lilburn, GA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3300.123456789012!2d-84.1234567!3d33.8901234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5a1234567890%3A0xabcdef1234567890!2sLilburn%2C%20GA!5e0!3m2!1sen!2sus!4v1710412345678!5m2!1sen!2sus",
    },
  },
};

export default config;
